import Icon from 'components/Icon';

const LoadingSpinner = ({ loading }) => {
    const spinnerClass = loading ? 'swing' : `no-swing`;

  return <Icon category="ui" name='tripPlanner' className={`trip-icon ${spinnerClass}`} />;
};

export default LoadingSpinner;
